import { defineEntity, custom } from './_helpers.js';

export default defineEntity(
    'verbis',
    {
        pending: custom({ scope: 'state' }),
    },
    { includeDefaultLifecycle: false },
);
